/* eslint-disable no-undef */
import { throttle } from '@fund/basic-lib/dist/lib/function';
import store from '../store/index';

function getPromise(name, params) {
  let result;
////////////////////////////////
  console.log(`调用原生${name}方法，参数：`, params);
  result = Promise.reject();
///////////////////////////////////
/////////////////////////////////////////////
////////////////////////////
///////////////////////////////////////////////
///////////////
/////////////
/////
//////////////////////
////////////////
/////////////////////////
/////////////////////
////////
//////////////////////
////////////////////
////////
///////
/////
///////////
  return result;
}

function getPromiseFund(name, params) {
  let result;
////////////////////////////////
  console.log(`调用原生${name}方法，参数：`, params);
  result = Promise.reject();
///////////////////////////////////
/////////////////////////////////////////////
//////////////////////
/////////////////////////////////////////
///////////////
/////////////
/////
////////////////
////////////////
/////////////////////////
/////////////////////
////////
//////////////////////
////////////////////
////////
///////
/////
///////////
  return result;
}

export function getIs50Sys() {
  let isnewPzy = false;
////////////////////////////////
  isnewPzy = false;
///////////////////////////////////
//////////////////////////////////////
/////////////////////////////////////////
////////////////////
///
///////////
  return isnewPzy;
}
export function getIsweb50Sys() {
  let isnewPzy = false;
////////////////////////////////
  isnewPzy = true;
///////////////////////////////////
//////////////////////////////////////
/////////////////////////////////////////
////////////////////
///
///////////
  return isnewPzy;
}
function safeCall(key, ...args) {
  if (!fundDetail[key]) {
    console.warn(`fundDetail 没有 ${key} 方法`);
    return undefined;
  }
  return fundDetail[key](...args);
}
/**
 * 添加自选
 * @param {基金code列表} fundCodes
 */
export function addOptionFund(fundCodes) {
  return getPromise('addOptionFund', {
    fundCodes,
  });
}

/**
 * 删除自选
 * @param {基金code} fundCode
 */
export function deleteOptionFund(fundCode) {
  return getPromise('deleteOptionFund', {
    fundCode,
  });
}

/**
 * 置顶自选
 * @param {基金code} fundCode
 */
export function topOptionFund(fundCode) {
  return getPromise('topOptionFund', {
    fundCode,
  });
}

/**
 * 获取基金自选状态
 */
export function getOptionFundState(fundCode) {
  return getPromise('getOptionFundState', {
    datas: {
      fCode: fundCode,
    },
  });
}

/**
 * 设置日历待提醒项
 * @param {配置参数对象} config
 */
export function setCalendarRemind(config) {
  return getPromise('setCalendarRemind', {
    ...config,
  });
}

/**
 * 查询日历待提醒项
 * @param {标题} title
 */
export function queryCalendarRemind(title) {
  return getPromise('queryCalendarRemind', { title });
}
/**
 * 打开日历待提醒项
 * @param {标题} title
 */
export function openCalendarRemind(title) {
  return getPromise('openCalendarRemind', { title });
}

/**
 * 东财购买  无回调
 * @param {配置参数对象} config
 */
export function emBuyFund(config) {
////////////////////////////////
  console.log('调用原生emBuyFund方法，参数：', config);
///////////////////////////////////
////////////////////////////////
///////////
}

/**
 * 登录判断，没登录去登陆，没解锁去解锁
 * @param {配置参数对象} config
 */
export function userLogin() {
  return getPromise('userLogin');
}

/**
 * 品种页分享 无回调
 * @param {配置参数对象} config
 */
export function shareFundDetail(config) {
////////////////////////////////
  console.log('调用原生 shareFundDetail 方法，参数：', config);
///////////////////////////////////
//////////////////////////////////////
///////////
}

/**
 * 获取原生详情数据
 * @param {基金code} fundCode
 */
export function getFundDetail(fundCode) {
  return getPromise('getFundDetail', {
    fCode: fundCode,
  });
}

/**
 * 设置导航条
 * @param {配置参数对象} config
 */
export function setNavTitle(config) {
  return getPromise('setNavigationBarTitle', {
    ...config,
  });
}

/**
 * 设置导航条
 * @param {配置参数对象} config
 */
export function setNavFundTitle(config) {
  return getPromiseFund('setNavigationBarTitle', {
    ...config,
  });
}

/**
 * 设置导航条 up down
 * @param {配置参数对象} config
 */
export function setNavBarScroll(config) {
  return getPromise('setNavigationBarScroll', {
    ...config,
  });
}

/**
 * 设置视频信息
 * @param {配置参数对象} config
 */
export function setScrollVideoData(code) {
  console.log('调用原生 setScrollVideoData 方法，参数：', code);
  // return getPromise('scrollVideoData', {
  //   hidden: code,
  // });
}

/**
 * 跳转大图
 * fundCode
 * fundType
 * market
 * mainType
 * timeType
 * costPrice
 * wfsyTip
 * @param {配置参数对象} config
 */
export function gotoBigChartView(config) {
  return getPromise('jumpBigChartView', {
    ...config,
  });
}

// 新加大图方法
export function gotoJumpBigChartView(config) {
  return getPromise('jumpBigChartPage', {
    ...config,
  });
}

export function closeBigChartView(config) {
////////////////////////////////
  console.log('调用原生 webFirstLoadOver 方法，参数：', config);
///////////////////////////////////
//////////////////////////////////////////////////////
////////////////////////////////////////
///////////
}

export function chartViewClose(config) {
////////////////////////////////
  console.log('调用原生 webFirstLoadOver 方法，参数：', config);
///////////////////////////////////
//////////////////////////////////////////////////////
/////////////////////////////////////
///////////
}

export function recordBrowseFund(config) {
  return getPromise('recordBrowseFund', {
    ...config,
  });
}

/**
 * 品种页分享 无回调
 * @param {配置参数对象} config
 */
export function pageFirstLoadOver(config) {
////////////////////////////////
  console.log('调用原生 webFirstLoadOver 方法，参数：', config);
///////////////////////////////////
//////////////////////////////////////////////////////
///////////////////////////////////////////////
///////////
}

/**
 * 品种页刷新开始
 * @param {配置参数对象} config
 */
export function pageStartRefresh(config) {
////////////////////////////////
  console.log('品种页刷新开始：', config);
///////////////////////////////////
///////////////////////////////////
///////////
}

/**
 * 品种页刷新结束
 * @param {配置参数对象} config
 */
export function pageEndRefresh(config) {
////////////////////////////////
  console.log('品种页刷新结束', config);
///////////////////////////////////
/////////////////////////////////
///////////
}

/**
 * 暂停品种页左右滑动
 * @param {配置参数对象} config
 */
export function stopHorizontalScroll(config) {
////////////////////////////////
  console.log('暂停品种页左右滑动', config);
///////////////////////////////////
///////////////////////////////////////////
///////////
}

/**
 * 打开品种页左右滑动
 * @param {配置参数对象} config
 */
export function openHorizontalScroll(config) {
////////////////////////////////
  console.log('打开品种页左右滑动', config);
///////////////////////////////////
///////////////////////////////////////////
///////////
}
/**
 * 调起评论键盘
 * @param {配置参数对象} config
 */
export function showCommentView(config) {
  return getPromise('showCommentView', {
    ...config,
  });
}
/**
 * 设置基金吧交互操作状态，关注和点赞
 * @param {配置参数对象} config
 */
export function getBarInteract(config) {
  return getPromise('getBarInteract', {
    ...config,
  });
}
/**
 * 设置基金吧交互操作状态，关注和点赞
 * @param {配置参数对象} config
 */
export function setBarInteract(config) {
  return getPromise('setBarInteract', {
    ...config,
  });
}
/**
 * 隐藏品种页loading
 * @param {配置参数对象} config
 */
export function hideDetailLoading(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
////////////////////////////////////////
///////////
}
/**
 * 设置视频信息
 * @param {配置参数对象} config
 */
export function setVideoData(config) {
  console.log('调用原生 setVideoData 方法，参数：', config);
  return getPromise('setVideoData', {
    ...config,
  });
}
/**
 * 设置替换fund信息
 * @param {配置参数对象} config
 */
export function replaceFundData(config) {
  console.log('调用原生 replaceFundData 方法，参数：', config);
  return getPromise('replaceFundData', {
    ...config,
  });
}
/**
 * 打开品种页左右滑动
 * @param {配置参数对象} config
 */
export function setVideoShowState(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
///////////////////////////////////
///////////
}
/**
 * onVideoVisible
 * @param {配置参数对象} config
 */
export function onVideoVisible(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////

/////////////////////////////////////
///////////
}
/**
 * onVideoVisible
 * @param {配置参数对象} config
 */
export function onVideoInvisible(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
///////////////////////////////////////
///////////
}

/** 存储公共缓存（同步方法）
 * setCommonStorageSync
 * @param {配置参数对象} config
 */
export function setCommonStorageSync(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
///////////////////////////////////////////
///////////
}

/** 存储公共缓存（同步方法）
 * getCommonStorageSync
 * @param {配置参数对象} config
 */
export function getCommonStorageSync(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
///////////////////////////////////////////
///////////
}

/** 去掉播放浮窗
 * hideFloatingVideoView
 * @param {配置参数对象} config
 */
export function hideFloatingVideoView(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
////////////////////////////////////////////
///////////
}
/**
 * 设置导航栏左右按钮
 * @param {配置参数对象} config
 */
export function setNavBar(config) {
  return getPromise('setNavigationBar', {
    ...config,
  });
}

/** 设置导航栏颜色
 *
 * @param {配置参数对象} config
 */
export function setNavBarColor(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
////////////////////////////////////////////
///////////
}

/** 返回
 *
 * @param {配置参数对象} config
 */
export function navBack(config) {
////////////////////////////////
  console.log('隐藏品种页loading：', config);
///////////////////////////////////
///////////////////////////////////
///////////
}

/** 跳转
 */
export function detailPushPageJump(object1, object2) {
  // console.log(`webPlatf ==== ${webPlatf}`);
  if (window.originhpla) {
    // eslint-disable-next-line
    if (fund) {
      // eslint-disable-next-line
      fund.navigateToApp(object1);
    }
    return;
  }
  const webPlatf = multi.$system.webPlatform;
  console.log('dddddddd', webPlatf);
  if (webPlatf === 'wxmp') {
    //
    if (object2 && object2.wxmp) {
      //
      multi.$router.push(object1, object2);
    } else {
      multi.$router.push({
        appId: 'fundb5035dd2ee584a',
        url: '/pages/public-offer-fund/index',
        params: {
          fundCode: store.state.native.fund.fundCode,
        },
      }, object2);
    }
  } else if (webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
    if (object2 && object2.web) {
      //
      multi.$router.push(object1, object2);
    } else {
      // multi.$router.push({
      //   appId: 'fundb5035dd2ee584a',
      //   url: '/pages/public-offer-fund/index',
      //   params: {
      //     fundCode: store.state.native.fund.fundCode,
      //   },
      // }, {
      //   url: `https://material.1234567.com.cn/low-code/e254683f706d14fbf26c0e965b7a6a47/index.html?schema=fund://mp.1234567.com.cn/weex/fundb5035dd2ee584a/pages/public-offer-fund/index?fundCode=${store.state.native.fund.fundCode}`,
      // });
      multi.$router.push({
        appId: 'fundb5035dd2ee584a',
        url: '/pages/public-offer-fund/index',
        params: {
          fundCode: store.state.native.fund.fundCode,
        },
      });
    }
  } else {
    console.log(object1);
    multi.$router.push(object1, object2);
  }
}
/** 跳转
 */
// eslint-disable-next-line max-len
const detailPushPage = throttle((object1, object2) => detailPushPageJump(object1, object2), 1000, { trailing: false });
export { detailPushPage };

/** 跳转
 */
export function detailMarketChannelPushPageJump(object1, object2) {
  const webPlatf = multi.$system.webPlatform;
  // console.log(`webPlatf ==== ${webPlatf}`);
  if (window.originhpla) {
    console.log('ddddddddq');
    // eslint-disable-next-line
    if (fund) {
      console.log('dddddddd');
      // eslint-disable-next-line
      fund.navigateToApp(object1);
    }
    return;
  }
  if (window.fd_marketChannel && window.fd_marketChannel.length > 0) {
//////////////////////////////////
    multi.$router.push({
      appId: 'fundb5035dd2ee584a',
      url: '/pages/public-offer-fund/index',
      params: {
        fundCode: store.state.native.fund.fundCode,
      },
    }, {
      url: `https://act.1234567.com.cn/topic/2021/open-account-channel/?marketChannel=${window.fd_marketChannel}`,
    });
    return;
/////////////
  }
  if (webPlatf === 'wxmp') {
    //
    if (object2 && object2.wxmp) {
      //
      multi.$router.push(object1, object2);
    } else {
      multi.$router.push({
        appId: 'fundb5035dd2ee584a',
        url: '/pages/public-offer-fund/index',
        params: {
          fundCode: store.state.native.fund.fundCode,
        },
      }, object2);
    }
  } else if (webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
    if (object2 && object2.web) {
      //
      multi.$router.push(object1, object2);
    } else {
      // multi.$router.push({
      //   appId: 'fundb5035dd2ee584a',
      //   url: '/pages/public-offer-fund/index',
      //   params: {
      //     fundCode: store.state.native.fund.fundCode,
      //   },
      // }, {
      //   url: `https://material.1234567.com.cn/low-code/e254683f706d14fbf26c0e965b7a6a47/index.html?schema=fund://mp.1234567.com.cn/weex/fundb5035dd2ee584a/pages/public-offer-fund/index?fundCode=${store.state.native.fund.fundCode}`,
      // });
      multi.$router.push({
        appId: 'fundb5035dd2ee584a',
        url: '/pages/public-offer-fund/index',
        params: {
          fundCode: store.state.native.fund.fundCode,
        },
      });
    }
  } else {
    multi.$router.push(object1, object2);
  }
}
/** 跳转
 */
// eslint-disable-next-line max-len
const detailMarketChannelPushPage = throttle((object1, object2) => detailMarketChannelPushPageJump(object1, object2), 1000, { trailing: false });
export { detailMarketChannelPushPage };

/**
 * 获取 启动中appstore 权限
 * @param {配置参数对象} config
 */
export function getIsIosApprove(config) {
  console.log('调用原生 getIsIosApprove 方法，参数：', config);
  return getPromise('getIsIosApprove', {
    ...config,
  });
}

/**
 * 获取 主接口请求线路
 */
export function getMainRequestLine() {
  let useB = false;
////////////////////////////////
  useB = false;
///////////////////////////////////
//////////////////////////////////////
///////////////////////
////////////////////////////////////////
/////////////////////////////////////////////////////////////
//////////////////////////////
//////////////////
/////
///
//////////////////////////////////////
/////////////////////////////////
////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
/////////////////////////////
//////////////////
/////
///
///////////
  if (useB) {
    // 使用2号线路，3.0.1版本 跟新时间 1小时
    return 'updateBasicInformationJH2';
  }
  // 使用主线路，2.0.1版本 跟新时间 30分钟
  return 'updateBasicInformationJH';
}
